exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select .el-select__tags .el-tag[data-v-f0dfbf2e]{display:none}", ""]);

// exports
